import React, {FC, useState} from 'react';
import { Button } from 'semantic-ui-react';

type Styles ={
    className?: string;
}

export const FuzzySearch: FC<Styles> = (props): JSX.Element => {
    const ls = localStorage.getItem('fuzzySearch') == 'false' ? false : true;
    const [exactSearch, setExactSearch] = useState(ls);
    
    const handleChange = () => {
        localStorage.setItem("fuzzySearch", JSON.stringify(!exactSearch));
        setExactSearch(!exactSearch);
    }
    
    return (
        <Button label='Exact search' content={exactSearch ? 'Yes' : 'No'} onClick={handleChange} className={props.className} />
    );
};